import CryptoJS from "crypto-js";
import moment from "moment";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
// import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { withTranslation } from "react-i18next";
import MobileInput from "../../../../_shared/MobileInput/MobileInput";

import { FormikProvider, useFormik } from "formik";
import worldcupImg1 from "../../../../assets/images/worldcup.svg";
import * as travelServices from "../../../../services/travel-service";
import CoveragePopup from "../../components/CoveragePopUp/coveragePopUp";
import Family from "../../components/Family/family";
import OtpPage from "../../components/OtpScreen/otpPage";
import travelConfig from "../../helpers/config";
import TravelInsuranceWrapper from "./style";

import { isEmpty } from "lodash";
import { Toast } from "primereact/toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import * as globalUtils from "../../../../helpers/utils";
import {
  setIsLoggedIn,
  setLoading,
  updateIsWorldCup,
  updateProposalRequest,
  updateTravelDetails,
  updateTravelGoogleTaggingData,
  updateTravelProposal,
  updateTravelQuotation,
} from "../../../../redux/actions/travel";
import * as commonServices from "../../../../services/common";
import ApplicantData from "../../components/homePage/ApplicantData";
import ProductCard from "../../components/ProductCard";
import QuoteModel from "../../components/QuoteModel/QuoteModel";
import * as utils from "../../helpers/utils";

import { submitCRMCampaignApi } from "../../../../services/crmApi";

function Calculate(props) {
  const { t, i18n } = props;

  const [showCoverageDetails, setShowCoverageDetails] = useState(false);
  const [coverageDetailsCode, setCoverageDetailsCode] = useState("");
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [showQuoteModel, setShowQuoteModel] = useState(false);
  const [searchQuotationData, setSearchQuotationData] = useState(false);
  const { self: applicant } = useSelector((state) => state.travel.applicants);
  const travelDetails = useSelector((state) => state.travel.travelDetails);
  const [productsList, setProductsList] = useState(travelConfig.products);
  const [pageBackgroundImg, setPageBackgroundImg] = useState(null);
  const [showCaptcha, setShowCaptcha] = useState(true);
  const [needFamilyToggler, setNeedFamilyToggler] = useState(true);
  const [isWCSelected, setIsWCSelected] = useState(false);
  const [selectedProductTitle, setSelectedProductTitle] = useState("");
  const [isValidCaptcha, setIsValidCaptcha] = useState(true);
  const { travelGoogleTaggingData } = useSelector((state) => state.travel);
  // const [isValidCaptcha, setIsValidCaptcha] = useState(false);
  const applicants = useSelector((state) => state.travel.applicants);
  const toast = useRef(null);
  const inputSection = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  
  const { businessLine } = useSelector((state) => state.travel);

  const isArabic = globalUtils.isArabic(props.i18n.language);
  const dispatch = useDispatch();
  const [familyCheckFlag, setFamilyCheckFlag] = useState();
  const [isInternal, setIsInternal] = useState(true);

  const sendOTP = useCallback(
    (mobileNumber, nationalId) => {
      dispatch(setLoading(true));
      const request = {
        idNumber: nationalId,
        mobile: globalUtils.prepareMobileNumber(mobileNumber),
        channel: "Portal",
        businessService: "StorePortal",
        language: globalUtils.getNumberRepresentedLanguageCode(
          props.i18n.language
        ),
        customText: "",
        module: "TRAVEL",
      };
      commonServices
        .sendOTPwithFlag(request)
        .then((response) => {
          dispatch(setLoading(false));
          if (response.data.status == "1" || response.status == "1") {
            toast.current.show({
              severity: "success",
              detail: props.t("otp-send-successfully"),
              life: 10000,
            });
            setShowOtpForm(true);
            setIsInternal(response?.data?.isInternal);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "otp_landing",
              ecommerce: {
                funnel_step: "step_4",
                step_name: "travel_Insurance_new_otp_landing",
                items: [
                  {
                    item_name: "Travel Insurance New",
                    item_category: "PNC Insurance",
                    item_class: "Individual",
                  },
                ],
              },
            });
          } else {
            // for Google tagging (failed to send otp)
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "error_displayed",
              error_location: "Travel Insurance New",
              funnel_step: "step_4",
              error_messages: response.data.statusDescritpion,
            });
            toast.current.show({
              severity: "error",
              detail: response.data.statusDescritpion,
              life: 10000,
            });
          }
        })
        .catch((err) => {
          dispatch(setLoading(false));
          // for Google tagging (failed to send otp)
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "error_displayed",
            error_location: "Travel Insurance New",
            funnel_step: "step_4",
            error_messages: JSON.stringify(err),
          });
        });
    },
    [toast, dispatch, props.i18n.language]
  );

  const formik = useFormik({
    initialValues: {
      productCode: travelDetails.productCode || "SS",
      deptDate: travelDetails.deptDate || "",
      returnDate: travelDetails.returnDate || "",
      email: travelDetails.email || "",
      contactNumber: travelDetails.contactNumber || "",
      yearBirth: travelDetails.yearBirth || "",
      nationalId: travelDetails.nationalId || "",
      ibanPrefix: "SA",
      mobilePrefix: "+966",
      month: travelDetails.month || "",
      year: travelDetails.year || "",
      captcha: false,
    },
    validate: (data) => {
      let errors = {};

      if (!data.productCode) {
        errors.productCode = t("please_select_any_product");
      }

      if (!data.deptDate) {
        errors.deptDate = t("departure_date_is_required");
      }

      if (!data.returnDate) {
        errors.returnDate = t("return_date_is_required");
      }
      if (!data.email) {
        errors.email = t("Email_is_required");
      } else if (!globalUtils.isValidEmail(data.email)) {
        errors.email = t("Invalid_email_address") + "E.g. example@email.com";
      }
      if (!data.nationalId) {
        errors.nationalId = t("National_ID_is_required");
      } else if (!globalUtils.isValidSaudiIDOrIQama(data.nationalId)) {
        errors.nationalId = t("Invalid-National-ID");
      }
      // if (!data.yearBirth) {
      // errors.yearBirth = t("date-of-birth-is-required");
      // }
      if (!data.month) {
        errors.month = t("date-of-birth-is-required");
      }
      if (!data.year) {
        errors.year = t("date-of-birth-is-required");
      }
      if (!data.contactNumber) {
        errors.contactNumber = t("contact-number-is-required");
      } else if (!globalUtils.isValidSaudiPhoneNumber(data.contactNumber)) {
        errors.contactNumber = t("Invalid_phone_format") + "5xxxxxxxx";
      }
      // if (!data.captcha) errors.captcha = t("Captcha_Error");
      return errors;
    },

    onSubmit: (data) => {
      //Lemnisk Code start
      // window.lmSMTObj.track("calculateClick", {
      //   productName: "Property & Casualty Insurance",
      //   subProductName: "Travel Insurance",
      //   travellingTo: data.productCode,
      //   departureDate: data.deptDate,
      //   returnDate: data.returnDate,
      //   "saudiID/iqamaID": data.nationalId,
      //   DOB: applicant.dobGreg,
      //   userName: applicant.fullNameEnglish,
      //   travellingWithFriendsOrFamily: familyCheckFlag
      //     ? familyCheckFlag == true
      //       ? "Yes"
      //       : "No"
      //     : "No",
      // });
      //Lemnisk Code end
      // for Google tagging (after user provides valid data)
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          funnel_step: "step_2",
          step_name: "travel_Insurance_new_add_to_cart",
          items: [
            {
              item_name: "Travel Insurance New",
              item_category: "PNC Insurance",
              item_class: "Individual",
              coverage_type: selectedProductTitle,
              departure_date: formik.values.deptDate,
              travelling_to: selectedProductTitle,
            },
          ],
        },
      });

      window.dataLayer.push({
        event: "begin_checkout",
        ecommerce: {
          funnel_step: "step_3",
          step_name: "travel_Insurance_new_begin_checkout",
          items: [
            {
              item_name: "Travel Insurance New",
              item_category: "PNC Insurance",
              item_class: "Individual",
              coverage_type: selectedProductTitle,
              departure_date: formik.values.deptDate,
              travelling_to: selectedProductTitle,
            },
          ],
        },
      });

      data["productFeatureCode"] = data.productCode;
      dispatch(updateTravelDetails(data));
      sendOTP(data.contactNumber, data.nationalId);
      // setShowOtpForm(true);
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const params = new URLSearchParams(location.search);
  const encMobile = params.get("mobile");
  const encYob = params.get("yob");
  const encId = params.get("id");
  const encmonth = params.get("month");
  const encyear = params.get("year");
  const encemail = params.get("email");

  useEffect(() => {
    localStorage.removeItem("productName");
    localStorage.removeItem("subProductName");
    // window.lmSMTObj.page(location.pathname, {
    //     path: location.pathname,
    //     language: globalUtils.isArabic(i18n.language) ? "Arabic" : "English",
    //     referrer: document.referrer,
    //     title: document.title,
    //     url: document.URL,
    //     search: "",
    // });
    //

    //   const mobile = CryptoJS.AES.decrypt(encMobile.split(" ").join("+"), "").toString(
    //     CryptoJS.enc.Utf8
    // );
    // const idx = CryptoJS.AES.decrypt(encId.split(" ").join("+"), "").toString(
    //     CryptoJS.enc.Utf8
    // );
    // const year = CryptoJS.AES.decrypt(encyear.split(" ").join("+"), "").toString(
    //     CryptoJS.enc.Utf8
    // );
    // const month = CryptoJS.AES.decrypt(encmonth.split(" ").join("+"), "").toString(
    //     CryptoJS.enc.Utf8
    // );
    // console.log(mobile,
    //     idx,
    //     year,
    //     month,"xxxx");

    //   console.log(encMobile,encId,encmonth,encyear,"encyearencyearencyear");
    if (encMobile) {
      const mobile = CryptoJS.AES.decrypt(
        encMobile.split(" ").join("+"),
        ""
      ).toString(CryptoJS.enc.Utf8);
      if (mobile) formik.setFieldValue("contactNumber", mobile);
    }
    if (encYob) {
      const yob = CryptoJS.AES.decrypt(
        encYob.split(" ").join("+"),
        ""
      ).toString(CryptoJS.enc.Utf8);
      if (yob) {
        let date = moment(yob, "DD-MM-YYYY").format("YYYY-MM-DD");
        formik.setFieldValue("yearBirth", date, "YYYY-MM-DD");
      }
    }
    if (encyear) {
      const year = CryptoJS.AES.decrypt(
        encyear.split(" ").join("+"),
        ""
      ).toString(CryptoJS.enc.Utf8);
      if (year) {
        formik.setFieldValue("year", +year);
      }
    }
    if (encmonth) {
      const month = CryptoJS.AES.decrypt(
        encmonth.split(" ").join("+"),
        ""
      ).toString(CryptoJS.enc.Utf8);
      if (month) {
        formik.setFieldValue("month", month);
      }
    }
    // const year = CryptoJS.AES.decrypt(encyear.split(" ").join("+"), "").toString(
    //     CryptoJS.enc.Utf8
    // );
    if (encId) {
      const id = CryptoJS.AES.decrypt(encId.split(" ").join("+"), "").toString(
        CryptoJS.enc.Utf8
      );
      if (id) formik.setFieldValue("nationalId", id);
    }

    if (encemail) {
      const email = CryptoJS.AES.decrypt(
        email.split(" ").join("+"),
        ""
      ).toString(CryptoJS.enc.Utf8);
      if (email) formik.setFieldValue("email", email);
    }
    //  for Google tagging (will be triggered once user lands on this page)
    if (encMobile || encYob || encId) {
      // do not trigger event if user lands from home page
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "view_item",
        ecommerce: {
          funnel_step: "step_0",
          step_name: "travel_Insurance_new_view_item",
          items: [
            {
              item_name: "Travel Insurance New",
              item_category: "PNC Insurance",
              item_class: "Individual",
              page_source: "internal_click", //calculated based on using document.referrer
            },
          ],
        },
      });
    }
  }, []);

  useEffect(() => {
    window.localStorage.removeItem("paramAttributes");
    if (params.size > 0) {
        window.localStorage.setItem(
          "paramAttributes",
          JSON.stringify(Object.fromEntries([...params]))
        );
    }
  }, [params]);

  const goToPayment = ({
    grandTotal,
    vatAmount,
    selectedProductTitle,
    travelGoogleTaggingData,
    data,
  }) => {
    dispatch(
      updateTravelGoogleTaggingData({
        fursan_mempership: "No",
        itemName: "Travel Insurance + Covid Insurance",
        itemPrice: grandTotal,
        coupon: "",
        travelling_to_sub_id: "TR-CD",
        tax: vatAmount,
      })
    );
    // for Google tagging step 5 and step 6 for worldcup travel google tagging
    // window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({
    //   event: "travel_new_policyCoverageComplete_v2",
    //   item_name: "Travel Insurance New",
    //   item_category: "Travel Insurance",
    //   item_class: "Individual",
    //   funnel_step: "step_7",
    //   travelling_to: selectedProductTitle,
    //   travelling_with_family: travelGoogleTaggingData?.travelling_with_family,
    //   travelling_with_friends: travelGoogleTaggingData?.travelling_with_family,
    //   num_travellers: +travelGoogleTaggingData?.num_travellers,
    //   num_days: +travelGoogleTaggingData?.num_days,
    //   fursan_mempership: "No",
    //   items: [
    //     {
    //       name: "Travel World Cup",
    //       id: "GC",
    //       price: +grandTotal,
    //     },
    //   ],
    // });
    dispatch(updateTravelQuotation(data));
    localStorage.setItem("travelQuotation", JSON.stringify(data));
    // navigate("/travel/payment", { replace: true });
    navigate(
      Boolean(businessLine)
        ? `/${businessLine}/travel/payment`
        : "/travel/payment",
      { replace: true }
    );
  };

  const onSuccessVerifyOTP = () => {
    // for Google tagging (after otp verification)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "otp_verified",
      ecommerce: {
        funnel_step: "step_5",
        step_name: "travel_insurance_new_otp_verified",
        items: [
          {
            item_name: "Travel Insurance New",
            item_category: "PNC Insurance",
            item_class: "Individual",
          },
        ],
      },
    });
    const localTravelDetail = {
      ...formik.values,
      //  productCode: "GC",
      //  productFeatureCode: "GC",
    };
    // if (isWCSelected) {
    //  localTravelDetail.productCode = "GC";
    //  localTravelDetail.productFeatureCode = "GC";
    //  dispatch(updateTravelDetails(localTravelDetail));
    // }
    //    ;
    const REQUEST = utils.buildTravelProposalRequest(
      { travelDetails: localTravelDetail, applicants },
      props.i18n.language
    );
    if (isWCSelected) {
      REQUEST["wcFlag"] = "Y";
    }

    //    ;
    const num_travellers = REQUEST?.ApplicantDetails?.length;
    dispatch(
      updateTravelGoogleTaggingData({
        travelling_to: selectedProductTitle,
        travelling_with_family: num_travellers > 1 ? "Yes" : "No",
        num_travellers,
        num_days: REQUEST?.duration,
        email: formik.values.email,
        phone: formik.values.contactNumber,
        travelling_to_id: formik.values.productCode,
      })
    );
    //    ;
    dispatch(updateProposalRequest(REQUEST));
    setShowOtpForm(false);
    dispatch(setLoading(true));
    travelServices
      .getTravelProposal(REQUEST, businessLine)
      .then((response) => {
        if (response.data.status == "SUCCESS" || response.data.status == "S") {
          dispatch(updateTravelProposal(response.data));
          dispatch(setIsLoggedIn(true));
          travelServices
            .searchQuotation(
              {
                IDNO: REQUEST.ApplicantDetails[0].idnumber,
                languageCode: globalUtils.getOneLetterLanguageCode(
                  props.i18n.language
                ),
                channelCode: businessLine ? "3" : "2",
                DOB: `${formik.values.year}`,
              },
              businessLine
            )
            .then((searchResponse) => {
              if (
                searchResponse?.data?.isOldQuote === "Y" &&
                (searchResponse?.data?.Status === "Success" ||
                  searchResponse?.data?.resultCode === "Success")
              ) {
                setSearchQuotationData(searchResponse.data);
                dispatch(setLoading(false));
                setShowQuoteModel(true);
              } else {
                if (isWCSelected) {
                  // get quotation request and navigate to payment
                  const travelQuotationRequest =
                    utils.buildTravelQoutationRequest(
                      { travelDetails: localTravelDetail, applicants },
                      props.i18n.language,
                      undefined,
                      businessLine
                    );
                  travelQuotationRequest["wcFlag"] = "Y";
                  travelServices
                    .createTravelQoutation(travelQuotationRequest, businessLine)
                    .then((response) => {
                      dispatch(setLoading(false));
                      if (response.data.Status === "Success") {
                        submitCRMCampaignApi(
                          response.data.QuotationNumber,
                          "TI"
                        );
                        goToPayment({
                          grandTotal: response.data?.GrandTotal,
                          vatAmount: response.data?.VATAmount,
                          selectedProductTitle,
                          travelGoogleTaggingData,
                          data: response.data,
                        });
                      } else {
                        // for Google tagging (step 6 error for worldcup travel)
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                          event: "error_displayed",
                          error_location: "Travel Insurance New",
                          funnel_step: "step_6",
                          error_messages: response.data.ResultMessage,
                        });
                        toast.current.show({
                          severity: "error",
                          detail: response.data.ResultMessage,
                        });
                      }
                    })
                    .catch((error) => {
                      // for Google tagging (step 6 error for worldcup travel)
                      window.dataLayer = window.dataLayer || [];
                      window.dataLayer.push({
                        event: "error_displayed",
                        error_location: "Travel Insurance New",
                        funnel_step: "step_6",
                        error_messages: JSON.stringify(error),
                      });
                      dispatch(setLoading(false));
                      toast.current.show({
                        severity: "error",
                        detail: "Somthing went wrong. Try Again!",
                      });
                    });
                } else {
                  dispatch(setLoading(false));
                  navigate("details", { replace: true });
                }
              }
            });
        } else {
          dispatch(setLoading(false));
          toast.current.show({
            severity: "error",
            detail: response.data.resultMessage,
          });
        }
      })
      .catch((error) => {
        dispatch(setLoading(false));
        toast.current.show({
          severity: "error",
          detail: "Something went wrong. Try again!",
        });
      });
  };

  const getPeriodSubDepartureAndReturnDate = () => {
    return formik.values.returnDate && formik.values.deptDate
      ? moment(formik.values.returnDate).diff(
          moment(formik.values.deptDate),
          "d"
        )
      : 0;
  };

  const isWhiteListed = (whiteListedList) => {
    if (getPeriodSubDepartureAndReturnDate() < 180) {
      return whiteListedList.includes("ST"); // Short Time
    }
    return whiteListedList.includes("LT"); // Long Time
  };

  const handleProductClick = (d, ele) => {
    formik.setFieldValue("productCode", d);
    if (ele.worldCup) {
      setIsWCSelected(true);
      dispatch(updateIsWorldCup(true));
    } else {
      // removing default dates selected for worldcup
      if (isWCSelected) {
        formik.setFieldValue("deptDate", "");
        formik.setFieldValue("returnDate", "");
      }
      setIsWCSelected(false);
      dispatch(updateIsWorldCup(false));
    }

    const selectedProduct = productsList.find(
      (product) => product.productCode === d
    );
    setSelectedProductTitle(t(selectedProduct.title));

    window.scrollTo({
      top: inputSection.current?.offsetTop,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    //
    if (formik.values.productCode) {
      const product = productsList.find(
        (ele) => ele.productCode === formik.values.productCode
      );
      if (!product) {
        formik.setFieldValue("productCode", "");
      }
      if (
        product?.whiteListPeriods &&
        !isWhiteListed(product.whiteListPeriods)
      ) {
        formik.setFieldValue("productCode", "");
      }
      if (product && product.bodyBgImg) setPageBackgroundImg(product.bodyBgImg);
      else if (pageBackgroundImg) setPageBackgroundImg(null);
      if (
        isWCSelected &&
        formik.values.deptDate?._i !== "2022-11-19" &&
        formik.values.returnDate?._i !== "2022-12-19"
      ) {
        formik.setFieldValue(
          "deptDate",
          moment(new Date()).format("YYYY-MM-DD")
        );
        formik.setFieldValue("returnDate", moment("2022-12-19", "YYYY-MM-DD"));
      }
      //&& product.disableCaptcha  >> if you wan to enable the captcha again add this condition inside the if statment
    }
  }, [formik.values]);

  //  useEffect(() => {
  //   if (isEmpty(applicants.self) && isWCSelected && !!formik.values.yearBirth) {
  //    formik.setFieldValue("yearBirth", null);
  //   }
  //  }, [applicants.self]);

  const [taggingStep1, setTaggingStep1] = useState(false);
  useEffect(() => {
    if (
      (!!formik.values.deptDate ||
        !!formik.values.returnDate ||
        !!formik.values.email ||
        !!formik.values.contactNumber ||
        !!formik.values.nationalId ||
        !!formik.values.yearBirth ||
        !!formik.values.month) &&
      !taggingStep1 &&
      !encId
    ) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "select_item",
        ecommerce: {
          funnel_step: "step_1",
          step_name: "travel_Insurance_new_select_item",
          items: [
            {
              item_name: "Travel Insurance New",
              item_category: "PNC Insurance",
              item_class: "Individual",
            },
          ],
        },
      });
      setTaggingStep1(true);
    }
  }, [
    formik.values.deptDate,
    formik.values.returnDate,
    formik.values.email,
    formik.values.contactNumber,
    formik.values.nationalId,
    formik.values.yearBirth,
    formik.values.month,
  ]);

  return (
    <TravelInsuranceWrapper>
      <Toast ref={toast} />
      <div
        style={{ backgroundImage: `url(${pageBackgroundImg})` }}
        className={`${pageBackgroundImg ? "worldcup_img_bg" : ""}`}
      >
        <div className={"container pt-5 " + (isArabic ? "ar" : "")}>
          <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit}>
              <div className="row">
                <div className="col-md-3 text-initial">
                  <h3 className={`${isWCSelected ? "text_color_wc" : ""}`}>
                    {t("where-are-you-traveling")}{" "}
                  </h3>
                </div>
                <div className="col-md-9">
                  <div className="row gx-3">
                    {productsList.map(
                      (ele, i) =>
                        isWhiteListed(ele.whiteListPeriods) && (
                          <div key={i} className="col-6 product-item">
                            <ProductCard
                              image={ele.icon}
                              title={t(ele.title)}
                              disabled={ele.disabled}
                              disableDetailsBtn={ele.disabled}
                              subTitle={t(ele.subTitle)}
                              productCode={ele.productCode}
                              isActive={
                                formik.values.productCode === ele.productCode
                              }
                              onSelect={(d) => handleProductClick(d, ele)}
                              onLinkClick={(_, code) => {
                                setShowCoverageDetails(true);
                                setCoverageDetailsCode(code);
                              }}
                              bgImg={ele.cardBgImg}
                              titleClasses={
                                ele.productCode === "GC-WC" && "text_color_wc"
                              }
                              subTitleClasses={
                                ele.productCode === "GC-WC" && "text_color_wc"
                              }
                              limits={ele.limits}
                            />
                          </div>
                        )
                    )}
                    <div className="col-12 text-initial">
                      {getFormErrorMessage("productCode")}
                    </div>
                  </div>
                </div>
              </div>
              <Divider />
              <div className="row" ref={inputSection}>
                <div className="col-md-3 text-initial">
                  <h3 className={`${isWCSelected ? "text_color_wc" : ""}`}>
                    {t("when")}
                  </h3>
                </div>
                <div className="col-md-9">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="field text-initial">
                        <Calendar
                          className={`w-100 custom-calendar-input ${classNames({
                            "p-invalid": isFormFieldValid("deptDate"),
                          })}`}
                          required={true}
                          placeholder={t("DepartureDate")}
                          dateFormat="yy-mm-dd"
                          inputClassName={`${classNames({
                            "p-invalid": isFormFieldValid("deptDate"),
                            lato: formik.values.deptDate,
                          })}`}
                          inputId="deptDate"
                          minDate={new Date()}
                          maxDate={new Date(moment().add(365, "d"))}
                          value={
                            formik.values.deptDate
                              ? new Date(formik.values.deptDate)
                              : ""
                          }
                          readOnlyInput
                          showIcon
                          onChange={(data) => {
                            formik.setFieldTouched("deptDate", true);
                            formik.setFieldValue("returnDate", "");
                            formik.setFieldValue(
                              "deptDate",
                              moment(data.value).format("YYYY-MM-DD")
                            );
                          }}
                          disabled={isWCSelected}
                        />
                        {getFormErrorMessage("deptDate")}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="field text-initial">
                        <Calendar
                          className={`w-100 custom-calendar-input custom-calendar-input-${businessLine} ${classNames(
                            {
                              "p-invalid": isFormFieldValid("returnDate"),
                            }
                          )}`}
                          custom-calendar-input
                          required={true}
                          placeholder={t("ReturnDate")}
                          dateFormat="yy-mm-dd"
                          inputClassName={`${classNames({
                            "p-invalid": isFormFieldValid("returnDate"),
                            lato: formik.values.returnDate,
                          })}`}
                          inputId="returnDate"
                          minDate={
                            // Discarding the Time and adding one day for next date
                            formik.values.deptDate
                              ? new Date(
                                  moment(formik.values.deptDate)
                                    .add(1, "d")
                                    .format("YYYY-MM-DD")
                                )
                              : new Date()
                          }
                          maxDate={
                            formik.values.deptDate
                              ? new Date(
                                  moment(formik.values.deptDate)
                                    .add(1, "y")
                                    .format("YYYY-MM-DD")
                                )
                              : null
                          }
                          value={
                            formik.values.returnDate
                              ? new Date(formik.values.returnDate)
                              : ""
                          }
                          readOnlyInput
                          showIcon
                          onChange={(data) => {
                            formik.setFieldTouched("returnDate", true);
                            formik.setFieldValue(
                              "returnDate",
                              moment(data.value).format("YYYY-MM-DD")
                            );
                          }}
                          disabled={isWCSelected}
                        />
                        {getFormErrorMessage("returnDate")}
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="col-12">
                      <div className="offer_wrapper">
                        <div className="offer_image">
                            <img src={CelebGIF} alt="celebration image" />
                        </div>
                        <div className="offer_desc">
                            <h3 className="desc_txt1">
                              Free 10 Days for Motor Insurance Holders
                            </h3>
                            <h4 className="desc_txt2">
                              Enjoy <b>10 Days</b> of Travel Insurance on us!, If you are Motor Insurance Holders.
                            </h4>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="row">
                  <div className="col-md-6">
                    <div className="field text-initial">
                      <InputText
                        className={`form-control ${classNames({
                          "p-invalid": isFormFieldValid("flightNumber"),
                        })}`}
                        type="text"
                        name="flightNumber"
                        placeholder={t("flight-no")}
                        value={formik.values.flightNumber}
                        onChange={formik.handleChange}
                      />
                      {getFormErrorMessage("flightNumber")}
                    </div>
                  </div>
                </div> */}
                </div>
              </div>
              <Divider />
              <div className="row mt-4">
                <div className="col-md-3 text-initial">
                  <h3 className={`${isWCSelected ? "text_color_wc" : ""}`}>
                    {props.t("tell-us-about-you")}
                  </h3>
                </div>
                <div className="col-md-9">
                  <ApplicantData
                    formik={formik}
                    isFieldValid={isFormFieldValid}
                    errorMessage={getFormErrorMessage}
                    isValidCaptcha={true}
                    setIsValidCaptcha={() => {}}
                  />
                  <div className="row">
                    <div className="col-md-6">
                      <div className="field text-initial">
                        <InputText
                          name="email"
                          keyfilter="email"
                          className={`form-control ${classNames({
                            "p-invalid": isFormFieldValid("email"),
                            lato: formik.values.email,
                          })}`}
                          placeholder={t("email")}
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {getFormErrorMessage("email")}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="field text-initial">
                        <MobileInput
                          withPrefix={true}
                          name="contactNumber"
                          className={`form-control ${classNames({
                            "p-invalid": isFormFieldValid("contactNumber"),
                            lato: formik.values.contactNumber,
                          })}`}
                          placeholder={t("contact-number")}
                          value={formik.values.contactNumber}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {getFormErrorMessage("contactNumber")}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <Family
                        familyChecked={!isEmpty(applicant)}
                        needFamilyToggle={needFamilyToggler}
                        setFamilyCheckFlag={setFamilyCheckFlag}
                      />
                    </div>
                  </div>
                  <div className="row mb-3">
                    {/* {i18n.resolvedLanguage !== "ar" && (
                      <Captcha
                        siteKey={process.env.REACT_APP_CAPTCHA_KEY}
                        onResponse={(token) => {
                          setIsValidCaptcha(true);
                          formik.setFieldValue("captcha", true);
                        }}
                        onExpire={() => setIsValidCaptcha(false)}
                      />
                    )}
                    {i18n.resolvedLanguage === "ar" && (
                      <Captcha
                        siteKey={process.env.REACT_APP_CAPTCHA_KEY}
                        onResponse={(token) => {
                          setIsValidCaptcha(true);
                          formik.setFieldValue("captcha", true);
                        }}
                        onExpire={() => setIsValidCaptcha(false)}
                        language="ar"
                      />
                    )}
                    {getFormErrorMessage("captcha")} */}
                  </div>
                </div>
              </div>

              <Divider />
              <div className="row pb-3">
                {!isWCSelected && (
                  <div
                    className={`col-md-12 ${
                      isArabic ? "text-initial" : "text-end"
                    }`}
                  >
                    <Button
                      // className="submit-btn mb-5"
                      className={
                        businessLine
                          ? `submit-btn-${businessLine}  mb-5`
                          : "submit-btn mb-5"
                      }
                      icon={
                        isArabic ? "pi pi-arrow-left px-1" : "pi pi-arrow-right"
                      }
                      label={t("calculate")}
                      iconPos="right"
                      type="submit"
                    />
                  </div>
                )}
              </div>
              {isWCSelected && (
                <div className="travel_wc_payment">
                  <div className="travel_wc_payment_price">
                    <img src={worldcupImg1} />
                    <span className="travel_wc_payment_price_text">
                      {t("worldcup.total_price")}
                    </span>
                    <span className="travel_wc_payment_price_sar">SAR</span>
                    <span className="travel_wc_payment_price_amt">170</span>
                  </div>
                  <div className={`${isArabic ? "text-initial" : "text-end"}`}>
                    <Button
                      className="submit-btn"
                      icon={
                        isArabic ? "pi pi-arrow-left px-1" : "pi pi-arrow-right"
                      }
                      label={t("common.pay-now")}
                      iconPos="right"
                      type="submit"
                    />
                  </div>
                </div>
              )}
            </form>
          </FormikProvider>
        </div>
      </div>
      <OtpPage
        show={showOtpForm}
        mobileNumber={formik.values.contactNumber}
        onSuccessVerify={onSuccessVerifyOTP}
        cancelOTP={() => setShowOtpForm(false)}
        forGoogleTagging={selectedProductTitle}
        nationalId={formik.values.nationalId}
        isInternal={isInternal}
        setIsInternal={setIsInternal}
        module="TRAVEL"
      />

      <CoveragePopup
        show={showCoverageDetails}
        onPopupClose={() => setShowCoverageDetails(false)}
        schengen={coverageDetailsCode == "SS"}
        gcc={coverageDetailsCode == "GC"}
        worldwide={coverageDetailsCode == "US"}
        // worldcup={coverageDetailsCode === "GC-WC"}
      />
      {showQuoteModel && (
        <QuoteModel
          showModel={showQuoteModel}
          onHide={() => setShowQuoteModel(false)}
          onContinueBtn={() => {
            setShowQuoteModel(false);
            goToPayment({
              grandTotal: searchQuotationData?.PriceDetails[0]?.GrandTotal,
              vatAmount: searchQuotationData?.PriceDetails[0]?.VATAmount,
              selectedProductTitle,
              travelGoogleTaggingData,
              data: {
                adminFee: searchQuotationData?.PriceDetails[0]?.adminFee,
                VATPercentage:
                  searchQuotationData?.PriceDetails[0]?.VATPercentage,
                VATableAmount:
                  searchQuotationData?.PriceDetails[0]?.totalAmount,
                PromotionDiscount:
                  searchQuotationData?.PriceDetails[0]?.PromotionDiscount,
                GrandTotal: searchQuotationData?.PriceDetails[0]?.GrandTotal,
                QuotationNumber: searchQuotationData?.quotationNumber,
                IDNO: searchQuotationData?.ApplicantDetails[0]?.id_no,
                VATAmount: searchQuotationData?.PriceDetails[0]?.VATAmount,
                totalPremium: searchQuotationData?.PriceDetails[0]?.totalAmount,
                Status: searchQuotationData?.resultCode,
                ApplicantDetails: [
                  {
                    name: searchQuotationData?.ApplicantDetails[0]?.name,
                    dob: searchQuotationData?.ApplicantDetails[0]?.dob,
                    premiumAmount:
                      searchQuotationData?.PriceDetails[0]?.totalAmount,
                  },
                ],
              },
            });
          }}
          onNewQuotation={() => {
            setShowQuoteModel(false);
            navigate("details", { replace: true });
          }}
        />
      )}
    </TravelInsuranceWrapper>
  );
}

export default withTranslation()(Calculate);
